import { Bet, BetSubmittedState, SbkBetslipReferrer, Selection } from '../types';
import { ComboSelectionState, isComboSelectionEnabled } from './betslip-utils';

// live-state twin of getShareConversions; the two rules must stay in step
export const hasImportedSelection = (bet: Bet, state: ComboSelectionState, importedOptionIds: string[]): boolean => {
    if (bet.betType === 'SINGLE') {
        return importedOptionIds.includes(bet.id);
    }
    return Object.values(state.selections).some(
        selection => importedOptionIds.includes(selection.optionId) && isComboSelectionEnabled(selection, state)
    );
};

// one conversion per placed bet holding an imported selection; an unstaked bet can't convert since
// the link service rejects a zero wager
export const getShareConversions = (
    submittedState: Pick<BetSubmittedState, 'singlesBets' | 'comboBet' | 'submittedBets'>,
    importedOptionIds: string[]
) => {
    const imported = new Set(importedOptionIds);

    // singles bets are keyed by their selection id
    const attributed = submittedState.singlesBets.filter(bet => imported.has(bet.id));
    if (submittedState.comboBet?.selections.some(selection => imported.has(selection.optionId))) {
        attributed.push(submittedState.comboBet.bet);
    }

    const globalIds = new Map(
        Object.values(submittedState.submittedBets).map(bet => [bet.localId, bet.globalId] as const)
    );

    // a bet PAM hasn't confirmed is skipped rather than reported under its local id, so the
    // referrer survives to convert on a placement that does confirm
    return attributed.flatMap(bet => {
        const entryId = globalIds.get(bet.id);
        return entryId && bet.stake ? [{ entryId, amount: bet.stake }] : [];
    });
};

export const retainReferrer = (
    referrer: SbkBetslipReferrer | undefined,
    selections: Record<string, Selection>
): SbkBetslipReferrer | undefined =>
    referrer?.optionIds.some(optionId => selections[optionId]) ? referrer : undefined;
